import type { FaireProductEntity } from "../../entity_types/product";

export const p_6p7ne95nmf: FaireProductEntity = {
  token: "p_6p7ne95nmf",
  type: "product",
  name: "Guava Protect & Repair Shampoo",
  brandToken: "b_4240zqg5kc",
  brandName: "Ceremonia",
  imageUrl:
    "https://cdn.faire.com/fastly/bcf222e87e643b900fa2464625fab82e20026a1f8b21f3367b488c7533f078d0.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 11.25,
  description: "Guava Protect & Repair Shampoo for wholesale.",
  tags: ["haircare"],
  caseSize: 6,
  msrpDollars: 22.5,
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-04-14T00:00:00.000Z",
    importedBy: "ceremonia-brand-prototype",
  },
  categoryTokens: [],
};
